
import { mapState } from "vuex";

export default {
  data() {
    return {
      data: null,
    };
  },
  filters: {
    description(string) {
      return string.substring(0, 200) + "...";
    },
    date(date) {
      let dateReg = date.match(/\d{2}(\d{2})-(\d{2})-(\d{2})/);
      return dateReg[3] + "/" + dateReg[2] + "/" + dateReg[1];
    },
  },
  computed: {
    ...mapState("blog", {
      categories: (state) => state.categories.data,
      blogTags: (state) => state.blogTags.data,
      featuredBlog: (state) => state.featuredBlog.data,
    }),
  },
};
